export default function attrsArrayToObject(attrsArray) {
	const attrs = {};

	attrsArray.forEach(attr => {
		attrs[attr.name] = attr.value;
	});

	return attrs;
}
